// extracted by mini-css-extract-plugin
export var button = "_ft-0";
export var donut = "_ft-1";
export var donutFill = "_ft-3";
export var donutTrack = "_ft-2";